/* eslint-disable */ // WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
const cognitoStagingConfig = {
    aws_project_region: 'ap-south-1',
    aws_cognito_identity_pool_id: 'ap-south-1:563fddea-2dae-4615-b241-26c091966844',
    aws_cognito_region: 'ap-south-1',
    aws_user_pools_id: 'ap-south-1_y73doXnwC',
    aws_user_pools_web_client_id: '3lejs5kpdmhcmkkhqnivnvg77b',
    oauth: {},
    authenticationFlowType: 'USER_PASSWORD_AUTH',
    aws_cloud_logic_custom: [
        {
            name: 'klaviyoapi',
            endpoint: 'https://yl0wr8cvy1.execute-api.ap-south-1.amazonaws.com/dev',
            region: 'ap-south-1'
        },
        {
            name: 'ordersapi',
            endpoint: 'https://sh45e3gzgf.execute-api.ap-south-1.amazonaws.com/dev',
            region: 'ap-south-1'
        }
    ]
};

export { cognitoStagingConfig as default };
//# sourceMappingURL=aws-exports-staging.js.map
